import { useState } from "react";
import ActionMenu, {
  ActionMenuItem,
} from "../../../../components/actionMenu/ActionMenu";
import { TableItemId } from "../../../../components/tables/TableWidget";
import { TableItemType } from "../../../../components/tables/tableContext/TableContext";
import { LabeledProductInterface } from "../../../../redux/interfaces/receipt.interface";
import AddReceivedProductModal from "./AddReceivedProductModal";

interface LabeledProductsTableActionProps {
  itemId: TableItemId;
  tableItemData: TableItemType[];
  crudData: LabeledProductInterface;
  receptionId?: string | number;
  onProductAdded: () => void | Promise<void>;
}

function LabeledProductsTableAction({
  crudData,
  receptionId,
  onProductAdded,
}: LabeledProductsTableActionProps) {
  const [showModal, setShowModal] = useState(false);
  const items: ActionMenuItem[] = [
    {
      id: "add-received-product",
      label: "Adauga",
      icon: "ADD",
      tooltip:
        "Deschide formularul pentru inregistrarea produsului, lotului si cantitatii primite dupa etichetare.",
      onClick: () => setShowModal(true),
    },
  ];

  return (
    <div className="text-left w-full">
      <ActionMenu
        items={items}
        minItemsForMenu={2}
        title={crudData.numeProdusErp}
        ariaLabel="Actiuni pentru produsul trimis etichetat"
      />

      <AddReceivedProductModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        receptionId={receptionId}
        labeledProduct={crudData}
        onProductAdded={onProductAdded}
      />
    </div>
  );
}

export default LabeledProductsTableAction;
